import { Link } from "react-router-dom";
import type { Episode } from "@/types/episode";

const facts = [
  { label: "类型", value: "都市情感 / 家庭" },
  { label: "集数", value: "全 16 集" },
  { label: "单集时长", value: "约 42 分钟" },
  { label: "首播时间", value: "2026.06.12" },
  { label: "语言", value: "韩语 / 中文字幕" },
  { label: "状态", value: "已完结" },
];

interface SynopsisBlockProps {
  featured: Episode;
}

export default function SynopsisBlock({ featured }: SynopsisBlockProps) {
  return (
    <div className="rounded-lg bg-background-100 border border-background-200/70 overflow-hidden">
      <div className="flex flex-col sm:flex-row">
        <div className="w-full sm:w-[210px] shrink-0 aspect-[2/3] sm:aspect-auto sm:h-auto relative bg-background-900">
          <img
            src={featured.cover}
            alt="朋友的妈妈4 官方海报"
            title="朋友的妈妈4 剧情简介"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-950/70 via-transparent to-transparent sm:bg-gradient-to-r sm:from-transparent sm:to-background-100/40" />
        </div>
        <div className="flex-1 p-4 md:p-6 min-w-0">
          <p className="text-[11px] tracking-[0.25em] uppercase text-primary-400 mb-2">
            剧情简介
          </p>
          <h3 className="font-heading text-xl md:text-2xl text-foreground-950">
            一栋旧公寓，两户人家，一段没人愿意提起的旧事
          </h3>
          <p className="mt-3 text-sm leading-7 text-foreground-500">
            年轻的摄影师志勋搬进老城区的旧公寓，与楼上的尹家成为邻居。母亲年轻时的旧友秀雅就住在这里，
            她温和、沉默，把整个家打理得井井有条，也把自己藏得很好。一次停电、一张旧照片、一场雨夜的长谈，
            让二十年前那段被搁置的往事重新浮出水面。
          </p>
          <p className="mt-2 text-sm leading-7 text-foreground-500">
            这不是一个关于越界的故事，而是关于一个人如何在中年的缝隙里，重新找回自己名字的故事。
          </p>

          <dl className="mt-5 grid grid-cols-2 sm:grid-cols-3 gap-x-4 gap-y-3">
            {facts.map((fact) => (
              <div key={fact.label} className="min-w-0">
                <dt className="text-[11px] text-foreground-600">{fact.label}</dt>
                <dd className="text-xs md:text-sm text-foreground-900 mt-0.5 truncate">
                  {fact.value}
                </dd>
              </div>
            ))}
          </dl>

          <Link
            to="/detail/ep-01"
            className="mt-6 inline-flex items-center gap-2 h-10 px-5 rounded-md bg-accent-500 hover:bg-accent-600 text-background-950 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            从第 1 集开始
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </div>
  );
}